import { useEffect, useState } from "react";
import Layout from "../../components/layoutMasterConfig/layoutMaster";
import { setupAPIclient } from "../../services/setupAPIclientAuth";
import { toast } from "react-toastify";
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientMater } from "../../services/setupClientMaster/apiClientMaster";
import edit from '../../components/dashboard/img/favicon/editar.png';


type DataRow = {
    id: number;
    categories: string;
    masterId: number;
};



function ConfigMaterCategories(){


    const [showDivregistered, showDivRegistered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showFormUpdate, setShowFormUpdate] = useState(false);
    const [formData, setFormData] = useState<{    
        categories: string;
        masterId: number;

    }>({
      masterId: 1,
      categories: ''
    });
    
    
  
      // Função para manipular a mudança nos inputs
      function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
        const { name, value } = e.target;  
        setFormData({
          ...formData,  
          [name]: value, 
        });
      };
    
  
  
  
      const resetForm = (enableModal:boolean) => {
        setFormData({
          categories: '',
          masterId: 1
        });

        if(enableModal){
            setShowModal(true)
        }

      };
      
    async function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault();


        if(formData.categories === ""){
          return  toast.warning("O campo nome não pode estar vazio!")
        }else{
          try {
            const ApiClient = apiClientMater();

            const response = await ApiClient.post("/crud/create/Category", {
                masterId: formData.masterId,
                categories: formData.categories
            });

            // Verifica se a requisição foi bem-sucedida (código HTTP 200-299)
            if (response.status >= 200 && response.status < 300) {
              toast.success("Cadastrado com sucesso! 🎉");

              resetForm(false);
              showDivRegistered(false);

              setTimeout(() => {
                window.location.reload();
            }, 1000);

            } else {
                throw new Error(`Erro inesperado: ${response.status}`);
            }
        } catch (error) {
            // Exibe a mensagem de erro mais detalhada possível
            const errorMessage =  "Erro ao registrar. Tente novamente.";
            toast.error(errorMessage);
        }
        }
    };

    const [filterText, setFilterText] = useState(""); 
    const [Iduser, setShowIduser] = useState(0);
    const [getData, setgetData] = useState<DataRow[]>([]);


    const columns: TableColumn<DataRow>[] = [
        {
            name: "Categorias",
            selector: (row) => row.categories,
            sortable: true,
            
        },
        {
          name: 'Ações',
          cell: (row: { id: number }) => (
            <button className='btn'  onClick={() => handleButtonUpdate(row.id)}>      
              <img src={edit} width={20} alt="Editar" />
            </button>
          ),
          ignoreRowClick: true, 
          allowOverflow: true,
          button: true
        },
      ];
 
  


      const handleButtonUpdate = (id: number) => {
        const selectedItem = getData.find((item) => item.id === id);
        setShowIduser(id)
        setFormData({
            masterId: selectedItem?.masterId ?? 1,
            categories: selectedItem?.categories ?? "",
        });
        setShowFormUpdate(true)
      }
      const filteredData = getData.filter(
        (item) =>
          item.categories?.toLowerCase().includes(filterText.toLowerCase()) ||
          item.categories?.toLowerCase().includes(filterText.toLowerCase()) 
      );
      const handleSubmitUpdate = async () => {
        // alert(Iduser)
        if(formData.categories === ""){
          return  toast.warning("O campo nome não pode estar vazio!")
        }else{

            const loadingToast = toast.info("Processando... aguarde", {
              autoClose: false, 
            });
            toast.dismiss(loadingToast);
      
      
            try {
              const ApiClient = apiClientMater();
              
              await ApiClient.post(`/crud/update/Category/${Iduser}`, {
                  id: Iduser,
                  categories: formData.categories,
                  masterId: 1,
              });
          
              toast.success("Atualizado com sucesso!");
          
              setTimeout(() => {
                  window.location.reload();
              }, 1000);
          } catch (error) {
          
              toast.dismiss(loadingToast);
          
              toast.error("Erro ao atualizar. Tente novamente.");
          }

        }
  
      
      }


      useEffect(() => {
        const handlegetActivisionData = async () => {
          const ApiClient = apiClientMater();
          const response = await ApiClient.post("/crud/Category");
    
            console.log(response.data)

            const formattedData = response.data.map((item: any) => ({
                id: item.id,
                categories: item.categories ?? "",
                masterId: item.masterId ?? null,
            }));

    
          setgetData(formattedData)
        }
        handlegetActivisionData();
      }, []);

    return (
        <Layout>
          <div>
         


         {!showFormUpdate ? (
         <div>

            <div className=' mr-3 mt-3 mb-3'>
                <button className='btn btn-success' onClick={() => resetForm(true) }>
                    Cadastrar Categorias
                </button>
            </div>

            <input
              type="text"
              placeholder="Filtrar por nome de categoria"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              style={{
                marginBottom: "10px",
                padding: "8px",
                width: "18%",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
            <DataTable  
              columns={columns}
              data={filteredData}
              pagination
              onSelectedRowsChange={(selected) =>
                console.log("Selected Rows: ", selected.selectedRows)
              }
              paginationComponentOptions={{
                rowsPerPageText: 'Página',
                rangeSeparatorText: 'de',
                selectAllRowsItem: true,
                selectAllRowsItemText: 'Selecionar todos'
              }}
            />

         </div>
        ) :  <div className='card mt-3'>
             <div className="modal-body ">
                    <form  method="POST">
                        <div className="form-group col-md-6 mt-2">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="categories"
                            id="name"
                            placeholder="Nome"
                            value={formData.categories}
                            onChange={handleChange}
                            required
                        />
                        </div>
                    </form>

                    <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowFormUpdate(false)}>Fechar</button>
                        <button className="btn btn-success" onClick={handleSubmitUpdate}>Editar</button>
                    </div>

             </div>
           </div>}
          </div>
          {/* Modal do Bootstrap */}
          {(showModal && !showFormUpdate) && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cadastrar Categorias</h5>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            <form  method="POST">
                                <div className="form-group col-md-6 mt-2">
                                <input
                                    type="text"
                                    className="fadeIn second form-control"
                                    name="categories"
                                    id="name"
                                    placeholder="Nome"
                                    value={formData.categories}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Fechar</button>
                            <button className="btn btn-success" onClick={handleSubmit}>Salvar</button>

                        </div>
                    </div>
                </div>
            </div>
          )}
          {/* Background escuro (overlay) */}
          {(showModal && !showFormUpdate) && <div className="modal-backdrop fade show"></div>}
        </Layout>
    )
}


export default ConfigMaterCategories;
